export function estimatedMinutesError(value: unknown): string | undefined {
    if (value === null || value === undefined) return undefined;
    return typeof value === 'number' && Number.isInteger(value) && value >= 1 && value <= 1440
        ? undefined : 'Enter a whole number of minutes from 1 to 1440, or leave blank.';
}
